import styles from './widget.css';
import { ENVIRONMENT, SERVER_URL_DEV, SERVER_URL_PROD } from './config';
const SERVER_URL = ENVIRONMENT === 'dev' ? SERVER_URL_DEV : SERVER_URL_PROD;

class AsaStateMapWidget extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
    this.loadFonts();
    this.render();
    this.shadowRoot.appendChild(styles.cloneNode(true));
    this.attachEventListeners();
  }

  loadFonts() {
    const fontId = 'google-font-raleway';
    if (!document.getElementById(fontId)) {
      const fontLink = document.createElement('link');
      fontLink.id = fontId;
      fontLink.href =
        'https://fonts.googleapis.com/css2?family=Raleway:wght@800&display=swap';
      fontLink.rel = 'stylesheet';
      document.head.appendChild(fontLink);
    }
  }

  attachEventListeners() {
    const header = this.shadowRoot.querySelector('.asa-widget-header');
    header.addEventListener('click', () => this.toggleForm());

    const form = this.shadowRoot.getElementById('asa-widget-form');
    form.addEventListener('submit', this.handleSubmit.bind(this));
  }

  async handleSubmit(event) {
    this.hideErrorMessage();
    event.preventDefault();
    const form = event.target;
    const formData = new FormData(form);
    const data = Object.fromEntries(formData.entries());
    data.newsletter = this.shadowRoot.getElementById('newsletter').checked;

    const submitButton = form.querySelector('button[type="submit"]');
    submitButton.disabled = true;
    submitButton.textContent = 'Submitting...';

    try {
      const response = await fetch(`${SERVER_URL}/api/v1/form-submit`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      });

      const submitResponse = await response.json();

      let url = null;

      if (!response.ok) {
        if (submitResponse.message) {
          console.error('Submit Error:', submitResponse.message);
        } else {
          console.error('Submit Error:', 'Unknown error');
        }
        this.showErrorMessage(submitResponse.message || 'Submission error.');
        submitButton.disabled = false;
        submitButton.textContent = 'Submit';
        return;
      } else {
        console.log('Submit Success:', submitResponse);
        url = submitResponse;

        submitButton.textContent = 'Redirecting...';
        // redirect to our site
        window.location.href = url;
      }
    } catch (error) {
      console.error('Error:', error);
      this.showErrorMessage();
    }
  }

  showErrorMessage(
    message = 'Sorry, we could not load the content at this time. Please try again later.',
  ) {
    const errorContainer = this.shadowRoot.querySelector(
      '.asa-widget-error-container',
    );
    errorContainer.style.display = 'block';
    const errorMessage = this.shadowRoot.querySelector(
      '.asa-widget-error-message',
    );
    errorMessage.textContent = message;
  }

  hideErrorMessage() {
    const errorContainer = this.shadowRoot.querySelector(
      '.asa-widget-error-container',
    );
    errorContainer.style.display = 'none';
  }

  toggleForm() {
    const formContainer = this.shadowRoot.querySelector(
      '.asa-widget-form-container',
    );
    if (formContainer.style.maxHeight) {
      formContainer.style.maxHeight = null;
    } else {
      formContainer.style.maxHeight = `${formContainer.scrollHeight}px`;
    }
  }

  render() {
    this.shadowRoot.innerHTML = `
            <style>
                .asa-widget-form-container {
                    max-height: 0;
                    overflow: hidden;
                    transition: max-height 0.5s ease-in-out;
                }
            </style>
            <div class="asa-widget-container">
              <div class="asa-widget-header">
                <h2 class="asa-widget-title">Medical Cannabis Laws & Regulations</h2>
                <h3 class="asa-widget-subtitle">Information for Patients, Caregivers, Medical Professionals & Advocates</h3>
                <div class="asa-widget-map-container">
                  <img 
                    src="https://assets.nationbuilder.com/americansforsafeaccess/pages/16659/attachments/original/1773086921/asa_state_map_2026_800px.png?1773086921" 
                    width="100%"
                    height="auto"
                    alt="Medical Cannabis Map" 
                    class="asa-widget-map"
                  >
                </div>
                <div class="asa-widget-error-container" style="display: none;">
                  <p class="asa-widget-error-message"></p>
                </div>
              </div>
              <div class="asa-widget-form-container">
                  <form id="asa-widget-form">
                    <div class="asa-form-group">
                        <label for="first-name">First Name</label>
                        <input type="text" id="first-name" name="first_name" required>
                    </div>
                    <div class="asa-form-group">
                        <label for="last-name">Last Name</label>
                        <input type="text" id="last-name" name="last_name" required>
                    </div>
                    <div class="asa-form-group">
                        <label for="email">Email</label>
                        <input type="email" id="email" name="email" required>
                    </div>
                    <div class="asa-form-group">
                        <label for="state">State/Territory</label>
                        <select id="state" name="state" required>
                            ${this.getStatesOptions()}
                        </select>
                    </div>
                    <div class="asa-form-group">
                        <label for="type">Looking for information for:</label>
                        <select id="type" name="type" required>
                            ${this.getTypeOptions()}
                        </select>
                    </div>
                    <div class="asa-form-group-checkbox">
                        <input type="checkbox" id="newsletter" name="newsletter" checked>
                        <label for="newsletter">Receive ASA newsletter</label>
                    </div>
                      <button type="submit" class="asa-widget-submit-button">Submit</button>
                  </form>
                  <div class="asa-widget-disclaimer">
                    <p>This information is provided by Americans for Safe Access and does not necessarily reflect our views or positions on medical cannabis policy.</p>
                    <img src="https://assets.nationbuilder.com/americansforsafeaccess/pages/16659/attachments/original/1773087232/asa_bug_2026_steph_300px.png?1773087232" alt="ASA Logo" class="asa-widget-logo">
                </div>
            </div>
        `;
  }

  getStatesOptions() {
    const states = [
      'Alabama',
      'Alaska',
      'Arizona',
      'Arkansas',
      'California',
      'Colorado',
      'Connecticut',
      'Delaware',
      'District of Columbia',
      'Florida',
      'Georgia',
      'Hawaii',
      'Idaho',
      'Illinois',
      'Indiana',
      'Iowa',
      'Kansas',
      'Kentucky',
      'Louisiana',
      'Maine',
      'Maryland',
      'Massachusetts',
      'Michigan',
      'Minnesota',
      'Mississippi',
      'Missouri',
      'Montana',
      'Nebraska',
      'Nevada',
      'New Hampshire',
      'New Jersey',
      'New Mexico',
      'New York',
      'North Carolina',
      'North Dakota',
      'Ohio',
      'Oklahoma',
      'Oregon',
      'Pennsylvania',
      'Rhode Island',
      'South Carolina',
      'South Dakota',
      'Tennessee',
      'Texas',
      'Utah',
      'Vermont',
      'Virginia',
      'Washington',
      'West Virginia',
      'Wisconsin',
      'Wyoming',
      'American Samoa',
      'Guam',
      'Northern Mariana Islands',
      'Puerto Rico',
      'U.S. Virgin Islands',
    ];
    return states
      .map((state) => `<option value="${state}">${state}</option>`)
      .join('');
  }

  getTypeOptions() {
    const types = [
      'Patient',
      'Caregiver',
      'Dispensary',
      'Doctor',
      'Nurse',
      'Nurse Practitioner',
      'Physician Assistant',
      'Pharmacist',
      'DDS',
      'DMD',
      'Other',
    ];
    return types
      .map((type) => `<option value="${type}">${type}</option>`)
      .join('');
  }
}

customElements.define('asa-state-map-widget', AsaStateMapWidget);

document.addEventListener('DOMContentLoaded', () => {
  const widgetContainers = document.querySelectorAll('.asa-state-map-widget');
  widgetContainers.forEach((container) => {
    const widget = new AsaStateMapWidget();
    container.replaceChild(widget, container.firstChild);
  });
});
